"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _IOs = _interopRequireDefault(require("@rsuite/icon-font/lib/platform/IOs"));

// Generated by script, don't edit it please.
var IOs = (0, _createSvgIcon["default"])({
  as: _IOs["default"],
  ariaLabel: 'i os',
  category: 'platform',
  displayName: 'IOs'
});
var _default = IOs;
exports["default"] = _default;
module.exports = exports.default;